import { FINANCE_TAX, LETTERHEAD } from '../constants/action.constant'

const initialState = {
    finance_tax: {},
    letterhead: {}
}

const saveFinanceTaxData = (state, action) => {
    const finance_tax = action.data?.data

    return ({
        ...state,
        finance_tax
    })
}
const saveLetterHeadData = (state, action) => {
    const letterhead = action.data?.data
    return ({
        ...state,
        letterhead
    })
}
const globalSettingReducer = (state = initialState, action) => {
    switch (action.type) {
        case FINANCE_TAX: return saveFinanceTaxData(state, action)
        case LETTERHEAD: return saveLetterHeadData(state, action)
        default: return state
    }
}

export default globalSettingReducer
